import React from 'react'
import { MultiSelect } from 'react-multi-select-component'

import styles from './style.module.css'
import { useJobSearch } from '@src/state/jobSearch'

export default function DatePostedFilter({ mobile }) {
  const options = [
    {
      label: 'Past week',
      value: 'now-7d/d',
    },
    {
      label: 'Past month',
      value: 'now-30d/d',
    },
    {
      label: 'Anytime',
      value: 'now-60d/d',
    },
  ]

  const dropdownOpts = options.map((item) => ({
    label: item.label,
    value: item.value,
  }))

  const { state, dispatch } = useJobSearch()

  const { filterStates } = state

  const selected = dropdownOpts
    .map((opt) => {
      if (filterStates.datePosted === opt.value) {
        return opt
      }
      return null
    })
    .filter((item) => item !== null)

  const handleSelect = (value) => {
    if (!value.length) return

    let updateWithThis

    for (let item of value) {
      if (item.value !== selected[0].value) {
        updateWithThis = item
      }
    }

    const dispatchObj = {
      type: 'setFilterStates',
      payload: { ...filterStates, datePosted: updateWithThis.value },
    }

    dispatch(dispatchObj)
  }

  const onValueChange = (e) => {
    const val = e.target.value

    const dispatchObj = {
      type: 'setFilterStates',
      payload: { ...filterStates, datePosted: val },
    }

    dispatch(dispatchObj)
  }

  if (mobile) {
    return (
      <div className={styles.mobileSelection}>
        <label>
          <input
            type="radio"
            value="now-7d/d"
            checked={state?.filterStates?.datePosted === 'now-7d/d'}
            onChange={onValueChange}
          />
          Past week
        </label>

        <label>
          <input
            type="radio"
            value="now-30d/d"
            checked={state?.filterStates?.datePosted === 'now-30d/d'}
            onChange={onValueChange}
          />
          Past month
        </label>

        <label>
          <input
            type="radio"
            value="now-60d/d"
            checked={state?.filterStates?.datePosted === 'now-60d/d'}
            onChange={onValueChange}
          />
          Any time
        </label>
      </div>
    )
  }

  return (
    <div style={{ zIndex: 10000 }}>
      <MultiSelect
        className={styles.datePostedDropdown}
        options={dropdownOpts}
        value={selected}
        onChange={handleSelect}
        labelledBy="Select"
        disableSearch
        ClearSelectedIcon={null}
        hasSelectAll={false}
        valueRenderer={customValueRenderer}
      />
    </div>
  )
}

const customValueRenderer = (selected, _options) => {
  return 'Date Posted  '
}
